import { Modal, Typography, MenuItem } from "@material-ui/core";
import { Box, FormControl, InputLabel, Select, Checkbox, FormControlLabel } from "@mui/material";
import { useState, useEffect } from "react";
import { DOMAIN_API_HOST } from "../../../configs/main";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const LEGAL_ENTITIES = [
  "Бизнес Солюшнс",
  "Программатик групп",
  "Кор Диджитал",
  "ИП Фиофанова",
];

function LegalEntityModal({ open, client, handleClose, onSaved }) {
  const [legalEntity, setLegalEntity] = useState("");
  const [isAgency, setIsAgency] = useState(false);

  useEffect(() => {
    if (client) {
      setLegalEntity(client.legal_entity || "");
      setIsAgency(Boolean(client.is_agency_payment));
    }
  }, [client]);

  const prevEntity = client?.legal_entity_previous;
  const changedAt = client?.legal_entity_changed_at
    ? new Date(
        new Date(client.legal_entity_changed_at).getTime() + 3 * 60 * 60 * 1000
      ).toLocaleString("ru-RU")
    : null;

  const handleSave = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    const res = await fetch(
      `${DOMAIN_API_HOST}/api/v1/admin/users/${client.id}`,
      {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify({
          legal_entity: legalEntity,
          is_agency_payment: isAgency,
        }),
      }
    );
    if (res.ok) {
      onSaved && onSaved(client.id, legalEntity, isAgency);
      handleClose();
    } else {
      const data = await res.json().catch(() => ({}));
      alert(data.detail || "Ошибка сохранения");
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="le-modal-title" aria-describedby="le-modal-desc">
      <Box sx={style}>
        <Typography id="le-modal-title" variant="h6" component="h2">
          Юр. лицо оплаты
        </Typography>
        <Typography
          id="le-modal-desc"
          style={{
            marginBottom: 24,
            marginTop: 8,
            color: "#42454C",
            opacity: "70%",
          }}
        >
          Клиент: {client?.email || client?.id}
        </Typography>
        <FormControl fullWidth size="small">
          <InputLabel id="le-select-label">Юр. лицо</InputLabel>
          <Select
            labelId="le-select-label"
            value={legalEntity}
            label="Юр. лицо"
            style={{ background: "#FFFFFF" }}
            onChange={(e) => setLegalEntity(e.target.value)}
          >
            {LEGAL_ENTITIES.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          style={{ marginTop: 20, gap: 8, alignItems: "center", marginLeft: 0 }}
          control={<Checkbox checked={isAgency} onChange={(e) => setIsAgency(e.target.checked)} />}
          label={<span style={{ fontSize: 14, fontWeight: 500 }}>Агентство</span>}
        />
        {(prevEntity || changedAt) && (
          <Box
            sx={{
              marginTop: 2,
              padding: "12px 16px",
              background: "#F7F8FA",
              borderRadius: "8px",
              fontSize: 13,
              color: "#42454C",
              lineHeight: 1.6,
            }}
          >
            {prevEntity && (
              <div>
                <span style={{ opacity: 0.6 }}>Было: </span>
                {prevEntity}
              </div>
            )}
            {changedAt && (
              <div>
                <span style={{ opacity: 0.6 }}>Дата изменения: </span>
                {changedAt}
              </div>
            )}
          </Box>
        )}
        <div className="leButtonGroup">
          <div className="leReset" onClick={handleClose}>
            Отменить
          </div>
          <div className="leConfirm" onClick={handleSave}>
            Сохранить
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default LegalEntityModal;
